import { render, staticRenderFns } from "./DetailInfoExamine.vue?vue&type=template&id=fa238e4c"
import script from "./DetailInfoExamine.vue?vue&type=script&lang=js"
export * from "./DetailInfoExamine.vue?vue&type=script&lang=js"
import style0 from "./DetailInfoExamine.vue?vue&type=style&index=0&id=fa238e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports